import * as React from 'react';
import {Button} from '@openfin/desktop-ui';

import {InfoList} from '../../../components/InfoList/InfoList';
import {useSystemInfo} from '../../../utils/useSystemInfo';

import * as Styles from './AboutSettings.module.scss';

const PROCESS_MANAGER_MANIFEST = 'https://cdn.openfin.co/process-manager/app.json';

export const AboutSettings: React.FC = () => {
    const systemInfo = useSystemInfo();
    const [organization, setOrganization] = React.useState<string>('...');
    React.useEffect(() => {
        // TODO: Make this obtainable from the REST service (and add to store?)
        setOrganization('OpenFin');
    });

    const tabularData = [
        {label: 'Organization', value: organization},
        {label: 'Runtime', value: systemInfo.runtime},
        {label: 'RVM Version', value: systemInfo.rvmVersion},
        {label: 'CPU', value: systemInfo.cpuUsage},
        {label: 'Memory', value: systemInfo.memUsage}
    ];

    const handleProcessManagerClick = () => {
        fin.Application.startFromManifest(PROCESS_MANAGER_MANIFEST).catch(() => {
            console.warn('Process manager already is running.');
        });
    };

    return (
        <div className={Styles['about-panel']}>
            <InfoList data={tabularData} />
            <Button className={Styles['process-monitor-button']} block onClick={handleProcessManagerClick}>
                Process Manager
            </Button>
        </div>
    );
};

